// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ly-0";
export var discountCodeInput = "_ly-1";